/** Canonical schedule shape for parent-form comparison (matches updateDetails / save input). */
export function normalizeWorkspaceSchedule(schedule: any): any {
	if (!schedule) return schedule;
	const wh = schedule.workinghours;
	return {
		enabled: !!schedule.enabled,
		items:
			schedule.items?.map((day: any, index: number) => ({
				day: day?.day ?? index,
				enabled: !!day?.enabled,
				items:
					day?.items?.map(({ from, to, name }: any) => ({
						from,
						to,
						...(name ? { name } : {}),
					})) ?? [],
			})) ?? [],
		...(wh && {
			workinghours: {
				dailyMaxHours: wh.dailyMaxHours,
				breakBetweenWorkingDays: wh.breakBetweenWorkingDays,
				minimumBreakDurationForCredit: wh.minimumBreakDurationForCredit,
				averageWorkingHours:
					wh.averageWorkingHours == null || wh.averageWorkingHours === ""
						? wh.averageWorkingHours
						: Number(wh.averageWorkingHours),
				averageWorkingHoursRange:
					wh.averageWorkingHoursRange == null || wh.averageWorkingHoursRange === ""
						? wh.averageWorkingHoursRange
						: Number(wh.averageWorkingHoursRange),
				breaks:
					wh.breaks?.map(({ minutesDue, workingHours }: any) => ({
						minutesDue,
						workingHours,
					})) ?? [],
				preventDeviatingWorkingHours: !!wh.preventDeviatingWorkingHours,
			},
		}),
	};
}
